import BaseApi from "../BaseApi";

class BaseStudy extends BaseApi{
    constructor() {
        super();
    }

    static getVersion() {
        return 1;
    }

}


export default BaseStudy;